<div class="app-info-panel__wrap w-100 flex-grow-1">
  <div class="info-panel__heading">{{ 'INFO' | translate }}</div>

  <div class="info-panel__notices">
    @if (isInfoMode()) {
      <div class="close" data-panel="">
        <div class="info-panel__notices_row" id="info-panel-step-1">
          <span class=""></span>
          <dx-button (onClick)="showProblems()" [elementAttr]="{ title: 'NOTIFICATIONS' | translate }">
            <i class="dx-icon mdi mdi-bell-ring-outline"></i>
            <span class="dx-button-text">
              @if (opened) {
                <span>{{ 'NOTIFICATIONS' | translate }}</span>
              }
              <span class="total-count">{{ (problems$ | async)?.length }}</span>
            </span>
          </dx-button>
        </div>
        <div class="info-panel__notices_row mb-4" id="info-panel-step-2" (click)="closeMenu()">
          <dx-button (onClick)="goToOrdersPage()" [elementAttr]="{ title: 'ORDERS' | translate }">
            <i class="dx-icon mdi mdi-open-in-new"></i>
            <span class="dx-button-text">
              @if (opened) {
                <span>{{ 'ORDERS' | translate }}</span>
              }
              <span class="total-count">{{ (orders$ | async)?.length }}</span>
            </span>
          </dx-button>
        </div>
        <div class="info-panel__notices_row" id="info-panel-step-3" (click)="closeMenu()">
          <dx-button (onClick)="goToStepsDiagnostic()" [elementAttr]="{ title: 'CREATE_ORDER' | translate }">
            <i class="dx-icon mdi mdi-clipboard-list-outline"></i>
            <span class="dx-button-text">
              @if (opened) {
                <span>{{ 'CREATE_ORDER' | translate }}</span>
              }
            </span>
          </dx-button>
        </div>
        <div class="info-panel__notices_row">
          <dx-button (onClick)="showMasterHelp()" [elementAttr]="{ title: 'TRAINING' | translate }" [disabled]="isDisabledInfo">
            <i class="dx-icon mdi mdi-help-circle-outline"></i>
            <span class="dx-button-text">
              @if (opened) {
                <span>{{ 'TRAINING' | translate }}</span>
              }
            </span>
          </dx-button>
        </div>
      </div>
    }

    @if (isProblemsMode()) {
      <div class="open" data-panel="">
        <div class="info-panel">
          <dx-button icon="mdi mdi-chevron-double-right" (onClick)="goToInfoPage()" class="btn-transparent close-problem"></dx-button>
          @if ((problems$ | async).length > 0) {
            <div class="notice-head">{{ 'NOTIFICATIONS' | translate }}</div>
          }
          @if ((problems$ | async).length === 0) {
            <div class="notice-head">{{ 'NOT_ACTIVE_MESSAGES' | translate }}</div>
          }
        </div>
        <div class="scroll">
          @for (problem of problems$ | async; track problem) {
            <app-problem-preview [problem]="problem" (click)="goToProblemPreviewPage(problem)" class="d-block"></app-problem-preview>
          }
        </div>
      </div>
    }
  </div>
</div>

<div class="profile">
  <div class="avatar">
    <img src="../../../../assets/images/nophoto.png" alt="avatar" />
  </div>
  <div>UserName</div>
</div>

<div class="social">
  <img src="../../../../assets/images/icon-viber.svg" alt="Viber" (click)="showViberPanel()" />
  <img src="../../../../assets/images/icon-telegram.svg" alt="Telegram" (click)="showTitlegramPanel()" />
</div>

<div class="btn-close ps-2 mb-2">
  @if (!opened && isInfoMode()) {
    <dx-button icon="mdi mdi-chevron-double-left" (onClick)="openOrCloseInfoPanel()" class="btn-transparent"></dx-button>
  }
  @if (opened && isInfoMode()) {
    <dx-button icon="mdi mdi-chevron-double-right" (onClick)="openOrCloseInfoPanel()" class="btn-transparent"></dx-button>
  }
</div>

<app-dialog-qrcode-link></app-dialog-qrcode-link>
